var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 894.12 668.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\r\n        opacity: 0.62;\r\n      }\r\n\r\n      .cls-2, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-3, .cls-30, .cls-31, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        mix-blend-mode: soft-light;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #ffbde7;\r\n      }\r\n\r\n      .cls-11, .cls-12, .cls-14, .cls-15, .cls-18, .cls-19, .cls-20, .cls-23 {\r\n        mix-blend-mode: multiply;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#radial-gradient);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#radial-gradient-2);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#radial-gradient-3);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#radial-gradient-4);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#radial-gradient-5);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#radial-gradient-6);\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: url(#radial-gradient-7);\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#linear-gradient-12);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#radial-gradient-8);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#linear-gradient-13);\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: url(#linear-gradient-14);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: url(#linear-gradient-15);\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: url(#linear-gradient-16);\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: url(#linear-gradient-17);\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: url(#linear-gradient-18);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#linear-gradient-19);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: url(#linear-gradient-20);\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: url(#linear-gradient-21);\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: url(#linear-gradient-22);\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: url(#linear-gradient-23);\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: url(#linear-gradient-24);\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: url(#linear-gradient-25);\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: url(#linear-gradient-26);\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: url(#linear-gradient-27);\r\n      }\r\n\r\n      .cls-39 {\r\n        fill: url(#linear-gradient-28);\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: url(#linear-gradient-29);\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: url(#linear-gradient-30);\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: url(#linear-gradient-31);\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: url(#linear-gradient-32);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 615.64,
    y1: -63.78,
    x2: 615.64,
    y2: -92.96,
    gradientTransform: "translate(34.05 659.19) rotate(-17.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7924b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#9125bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ad26c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b726c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 821.62,
    y1: -143.28,
    x2: 821.62,
    y2: -191.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 214.05,
    y1: -150.74,
    x2: 214.05,
    y2: -199.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 144.34,
    y1: -119.12,
    x2: 144.34,
    y2: -167.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 261.39,
    y1: -46.56,
    x2: 261.39,
    y2: -94.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 438.82,
    y1: -235.01,
    x2: 438.82,
    y2: -283.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 660.78,
    y1: -181.25,
    x2: 660.78,
    y2: -210.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 774.21,
    cy: 1069.9,
    r: 74.58,
    gradientTransform: "matrix(0, 1.34, -1.11, 0, 1587.3, -682.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3c067d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4d1c89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#997cbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d0c3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#f2eef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 851.44,
    cy: 1086.13,
    r: 74.58,
    gradientTransform: "matrix(0, 1.34, -1.11, 0, 1692.28, -726.82)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 387.29,
    y1: 428.89,
    x2: 507.77,
    y2: 633.13,
    gradientTransform: "translate(51.16 -229.38) rotate(6.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b22aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#b42ce7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#d44996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#eb5f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fa6c35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7127"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 1315.19,
    cy: -1103.64,
    r: 49.45,
    gradientTransform: "matrix(1.86, 0, 0, 0.97, -2254.63, 1369.53)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 998.45,
    cy: -116.06,
    r: 47.61,
    gradientTransform: "matrix(1.61, 0, 0, 0.79, -1222.94, 259.31)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 256.5,
    y1: 71.06,
    x2: 311.13,
    y2: 159.13,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -15.46, 137.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d82a82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#e9465a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f95f35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6927"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 283.72,
    y1: 288.07,
    x2: 339.82,
    y2: 378.52,
    gradientTransform: "matrix(1.02, 0.07, -0.07, 1.07, -32.11, -161.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d0e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#670b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#7d03b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8500c0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 2615.14,
    cy: 2399.79,
    r: 80.5,
    gradientTransform: "matrix(-1.5, 0, 0, -0.79, 4603.5, 2324.52)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 3036.43,
    cy: 1200.65,
    r: 92.62,
    gradientTransform: "matrix(-1.47, 0, 0, -0.79, 5087.87, 1511.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f4f2f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e7e0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d4c8e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#bca9d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9e83be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7a55a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#52228c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c067d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 3503.3,
    cy: 1067.03,
    r: 57.34,
    gradientTransform: "matrix(-1.25, 0, 0, -0.84, 4814.96, 1444.32)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 3874.37,
    y1: 545.77,
    x2: 3935.16,
    y2: 643.78,
    gradientTransform: "translate(4493.86 1080.83) rotate(180)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 3829.52,
    y1: 262.88,
    x2: 3895.66,
    y2: 369.51,
    gradientTransform: "matrix(-1.02, -0.14, 0.15, -1.06, 4489.01, 1380.35)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 163.61,
    cy: -1067.72,
    r: 81.54,
    gradientTransform: "matrix(0.76, 0, 0, 0.62, 274.75, 1119.34)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 442,
    y1: 872.17,
    x2: 453.14,
    y2: 768.54,
    gradientTransform: "matrix(0.97, 0.23, -0.23, 0.97, 151.89, -460.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c54aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#a72bc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8a0ca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f0095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 134.91,
    y1: 629.74,
    x2: 303,
    y2: 461.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fffeff",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fffcfe",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#fff8fe",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3fd",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffecfc",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ffe4fa",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ffdaf8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd3f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 531.57,
    y1: 258.33,
    x2: 747.82,
    y2: 42.07,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 326.63,
    y1: 449.71,
    x2: 469.78,
    y2: 306.56,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 402.1,
    y1: 305.27,
    x2: 593.82,
    y2: 305.27,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 640.46,
    y1: 441.28,
    x2: 800.98,
    y2: 280.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd3f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffdaf8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ffe4fa",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ffecfc",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3fd",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#fff8fe",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fffcfe",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fffeff",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 113.16,
    y1: 369.41,
    x2: 257.46,
    y2: 225.11,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 461.15,
    y1: 610.52,
    x2: 577.42,
    y2: 494.24,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 625.43,
    y1: -169.75,
    x2: 648.27,
    y2: -169.75,
    gradientTransform: "translate(45.65 666.21) rotate(-17.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b22aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#c138c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#dc5082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ef6251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fb6d32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 172.04,
    y1: -213.39,
    x2: 194.88,
    y2: -213.39,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 717.72,
    y1: -120.52,
    x2: 740.56,
    y2: -120.52,
    gradientTransform: "translate(45.65 666.21) rotate(-17.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 537.65,
    y1: -49,
    x2: 560.49,
    y2: -49,
    gradientTransform: "translate(45.65 666.21) rotate(-17.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 769.68,
    y1: -161,
    x2: 792.51,
    y2: -161,
    gradientTransform: "translate(45.65 666.21) rotate(-17.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 389.33,
    y1: -298.42,
    x2: 412.17,
    y2: -298.42,
    gradientTransform: "translate(45.65 666.21) rotate(-17.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 317.9,
    y1: -159.3,
    x2: 340.73,
    y2: -159.3,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 337.16,
    y1: -39.81,
    x2: 360,
    y2: -39.81,
    gradientTransform: "translate(45.65 666.21) rotate(-17.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 550.3,
    y1: 269.22,
    x2: 567.17,
    y2: 252.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 584.81,
    y1: 397.29,
    x2: 601.67,
    y2: 380.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 224.7,
    y1: 422.4,
    x2: 241.56,
    y2: 405.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 271.04,
    y1: 359.72,
    x2: 287.91,
    y2: 342.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-21"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M664,391.51l-125.53,40A14.58,14.58,0,0,1,520.17,422h0a14.58,14.58,0,0,1,9.47-18.33l125.53-40a14.58,14.58,0,0,1,18.33,9.47h0A14.58,14.58,0,0,1,664,391.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M877.3,240.12,669.48,306.34a24.16,24.16,0,0,1-30.35-15.68h0a24.16,24.16,0,0,1,15.68-30.35l207.82-66.22A24.16,24.16,0,0,1,893,209.77h0A24.16,24.16,0,0,1,877.3,240.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.13,417.47,88.32,483.69A24.16,24.16,0,0,1,58,468h0a24.16,24.16,0,0,1,15.68-30.35l207.82-66.22a24.15,24.15,0,0,1,30.34,15.68h0A24.16,24.16,0,0,1,296.13,417.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M239.31,468.76,31.5,535A24.15,24.15,0,0,1,1.15,519.3h0A24.16,24.16,0,0,1,16.83,489l207.81-66.22A24.16,24.16,0,0,1,255,438.41h0A24.16,24.16,0,0,1,239.31,468.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M372.87,502.37,165.06,568.59a24.15,24.15,0,0,1-30.35-15.69h0a24.15,24.15,0,0,1,15.68-30.34L358.2,456.34A24.16,24.16,0,0,1,388.55,472h0A24.16,24.16,0,0,1,372.87,502.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M484.71,268.94,276.9,335.16a24.16,24.16,0,0,1-30.35-15.68h0a24.16,24.16,0,0,1,15.68-30.35L470,222.91a24.15,24.15,0,0,1,30.35,15.69h0A24.15,24.15,0,0,1,484.71,268.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M671.37,265.89l-125.53,40a14.59,14.59,0,0,1-18.33-9.48h0A14.58,14.58,0,0,1,537,278.08l125.53-40a14.58,14.58,0,0,1,18.33,9.47h0A14.59,14.59,0,0,1,671.37,265.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M493.48,462.29c-14.11-.82-24.12-8.91-35.52-18.13-14-11.29-29.79-24.08-57.31-25.7C375.71,417,356,408.17,343.58,392.94c-13.16-16.17-18-39.29-13.92-66.86,7-47.91,56-87.61,111.57-90.37,49.35-2.46,80.65,19.15,98.22,37.71,21.74,22.95,35.32,54.87,37.27,87.57,2.83,47.53-20.16,97.27-77.88,101.27A43.71,43.71,0,0,1,493.48,462.29ZM441.26,236.21l0,.5c-55.07,2.74-103.66,42.06-110.63,89.51-4,27.29.73,50.15,13.7,66.09,12.22,15,31.71,23.71,56.36,25.16,27.84,1.63,43.8,14.53,57.88,25.92,12.63,10.2,23.53,19,40.18,17.87,57-3.95,79.75-53.17,77-100.21-1.93-32.47-15.41-64.16-37-86.95-17.42-18.4-48.48-39.83-97.44-37.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 395.17,
    cy: 354.47,
    rx: 83.1,
    ry: 99.87,
    transform: "translate(-90.21 569.45) rotate(-65.78)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 482.08,
    cy: 413.38,
    rx: 83.1,
    ry: 99.87,
    transform: "translate(-92.68 683.45) rotate(-65.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M421,246.5c-115.87,8.56-129.18,150.55-57,162.38,101.94,16.71,69.28,57.32,139.53,49.57C584.24,449.54,594.77,233.65,421,246.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M472.2,473.61c-14.13,0-24.59-7.5-36.51-16-14.59-10.47-31.13-22.32-58.7-22.34-25,0-45.2-7.69-58.46-22.18-14.07-15.37-20.21-38.18-17.76-65.94,4.25-48.24,50.87-90.7,106.15-96.68,49.12-5.31,81.62,14.45,100.24,32,23,21.65,38.44,52.73,42.27,85.27,5.58,47.28-14.49,98.27-71.88,105.6A41.5,41.5,0,0,1,472.2,473.61ZM407,250.93l0,.49c-54.81,5.93-101,48-105.26,95.78-2.42,27.47,3.63,50,17.51,65.18,13.07,14.27,33,21.83,57.72,21.85,27.89,0,44.57,12,59.29,22.52,13.19,9.46,24.59,17.63,41.14,15.52,56.72-7.25,76.54-57.7,71-104.5-3.81-32.3-19.11-63.16-42-84.66-18.47-17.36-50.71-37-99.45-31.69Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 185.73,
    cy: 298.73,
    rx: 91.75,
    ry: 47.97,
    transform: "translate(-163.97 260.7) rotate(-51.92)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 388.98,
    cy: 167.3,
    rx: 76.87,
    ry: 37.77,
    transform: "translate(-25.74 81.85) rotate(-11.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M330.23,157.62c-45.36,48.78-69.44,88.57-147.43,88-36-.28-58.32-15.66-58.32-15.66s-27.56,78.15-25.33,85.51c5,16.49,95.34,60.38,135-11.16,91.93-165.69,146.92-61.11,206.25-124.93C485,131.44,389,94.44,330.23,157.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M345,153.44c-58.66,58-86.4,89-170.64,64.1C138.87,207.07,115.57,185,115.57,185S79.7,281.27,80.9,289.38c2.69,18.17,102.19,72.91,147.8,2.87,86.78-133.31,130.52-87.58,171-90.81,37.57-3,53.72-35.65,47.38-54C434,109.59,383.24,115.62,345,153.44Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M519.11,563.1c56.46-53.33,88-97.38,178.67-90.33,41.87,3.25,66.57,23,66.57,23S793.7,391,791.71,382.29C787.25,362.71,686.86,310.75,630,417,523.6,615.78,430.61,469.17,386.78,547.77,348.11,617.1,467.26,612.07,519.11,563.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M511.71,585.16C577,536.76,616.81,482.6,708,502.94c42.1,9.39,63.08,45.78,63.08,45.78s49.55-109.07,48.82-118.61c-1.64-21.35-118.29-96.89-171.7-15.36C526.2,601,438.75,473.84,404.47,526.63,366.6,584.93,451.75,629.61,511.71,585.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 399,
    cy: 456.91,
    rx: 61.93,
    ry: 50.59,
    transform: "translate(-193.94 328.91) rotate(-36.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M434.25,406.23c-20.07-14.15-55.57-18.59-70.67-.36-24.79,29.93-9.92,101.53,59.18,71.27C460.84,460.45,456.4,421.85,434.25,406.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M610.41,310.33,592.7,316a2.12,2.12,0,0,1-2.67-1.38h0a2.13,2.13,0,0,1,1.38-2.67l17.71-5.64a2.13,2.13,0,0,1,2.67,1.38h0A2.13,2.13,0,0,1,610.41,310.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M165.17,406.39,147.46,412a2.13,2.13,0,0,1-2.67-1.38h0a2.12,2.12,0,0,1,1.38-2.67l17.71-5.65a2.14,2.14,0,0,1,2.67,1.38h0A2.12,2.12,0,0,1,165.17,406.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M713.29,329.22l-17.71,5.64a2.12,2.12,0,0,1-2.67-1.38h0a2.12,2.12,0,0,1,1.38-2.67L712,325.17a2.13,2.13,0,0,1,2.67,1.38h0A2.14,2.14,0,0,1,713.29,329.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M563.43,452l-17.71,5.64a2.12,2.12,0,0,1-2.67-1.38h0a2.13,2.13,0,0,1,1.38-2.67L562.14,448a2.12,2.12,0,0,1,2.67,1.38h0A2.12,2.12,0,0,1,563.43,452Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M750.5,274.88l-17.71,5.64a2.12,2.12,0,0,1-2.67-1.38h0a2.13,2.13,0,0,1,1.38-2.67l17.71-5.64a2.12,2.12,0,0,1,2.67,1.38h0A2.13,2.13,0,0,1,750.5,274.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M346.38,259.41l-17.7,5.64a2.13,2.13,0,0,1-2.68-1.38h0a2.14,2.14,0,0,1,1.38-2.67l17.71-5.64a2.12,2.12,0,0,1,2.67,1.38h0A2.12,2.12,0,0,1,346.38,259.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M320.56,413.66l-17.71,5.64a2.13,2.13,0,0,1-2.67-1.38h0a2.14,2.14,0,0,1,1.38-2.67l17.71-5.64a2.12,2.12,0,0,1,2.67,1.38h0A2.12,2.12,0,0,1,320.56,413.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M375.2,521.66l-17.71,5.64a2.12,2.12,0,0,1-2.67-1.38h0a2.12,2.12,0,0,1,1.38-2.67l17.7-5.64a2.13,2.13,0,0,1,2.68,1.38h0A2.14,2.14,0,0,1,375.2,521.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M565.42,259.27h0a5.17,5.17,0,0,1-5.16-5.17h0a1,1,0,0,0-.85-1,.93.93,0,0,0-1,.93v0a5.17,5.17,0,0,1-5.17,5.17h0a1,1,0,0,0-1,.84.94.94,0,0,0,.93,1h0a5.16,5.16,0,0,1,5.17,5.16h0a1,1,0,0,0,.85,1,.94.94,0,0,0,1-.94v0a5.16,5.16,0,0,1,5.16-5.16h0a1,1,0,0,0,.94-1A1,1,0,0,0,565.42,259.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M599.93,387.34h0a5.16,5.16,0,0,1-5.17-5.16h0a1,1,0,0,0-.85-1,1,1,0,0,0-1,.93v.05a5.16,5.16,0,0,1-5.16,5.16h0a1,1,0,0,0-1,.85.94.94,0,0,0,.94,1h0a5.16,5.16,0,0,1,5.16,5.17h0a1,1,0,0,0,.85,1,.94.94,0,0,0,1-.93v0a5.16,5.16,0,0,1,5.17-5.17h0a.93.93,0,0,0,.93-1A1,1,0,0,0,599.93,387.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M239.82,412.44h0a5.16,5.16,0,0,1-5.17-5.16h0a1,1,0,0,0-.85-1,.94.94,0,0,0-1,.94v0a5.16,5.16,0,0,1-5.17,5.16h0a1,1,0,0,0-1,.85.94.94,0,0,0,.93,1h0a5.17,5.17,0,0,1,5.17,5.17h0a1,1,0,0,0,.85,1,.93.93,0,0,0,1-.93v0a5.17,5.17,0,0,1,5.17-5.17h0a.94.94,0,0,0,.93-1A1,1,0,0,0,239.82,412.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M286.16,349.77h0A5.17,5.17,0,0,1,281,344.6h0a1,1,0,0,0-.84-1,.94.94,0,0,0-1,.93v0a5.17,5.17,0,0,1-5.17,5.17h0a1,1,0,0,0-1,.85.93.93,0,0,0,.93,1h0a5.17,5.17,0,0,1,5.17,5.17h0a1,1,0,0,0,.84,1,.94.94,0,0,0,1-.93v0a5.17,5.17,0,0,1,5.17-5.17h0a.94.94,0,0,0,.94-1A1,1,0,0,0,286.16,349.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M137,334.13c-15.12,0-32.23-4.41-52-14.91l.47-.89C161.2,358.63,198.3,308.25,231,263.8c16.64-22.6,32.35-43.94,51.59-51.66,31-12.44,49.24-7.61,68.53-2.48,14.62,3.88,29.74,7.89,51.72,5,9.51-1.24,33.77-5.77,53.64-21.09,18.16-14,26.69-33,24.67-54.9l1-.09c2.05,22.28-6.61,41.57-25.06,55.79-20.07,15.46-44.53,20-54.12,21.28-22.18,2.89-37.39-1.15-52.11-5.06-19.12-5.08-37.19-9.87-67.9,2.45-19,7.61-34.61,28.84-51.16,51.32C207.37,297.61,180.48,334.13,137,334.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M409.51,580.47c-5.82-20.31-3.69-37.51,6.32-51.12,13.14-17.86,36.83-24.66,54.61-25.07,21.17-.49,36.63.56,50.26,1.49,25.35,1.73,43.67,3,80.08-6.31,35.05-8.95,59.39-31.3,80.87-51,36.27-33.3,67.59-62.05,135.28-17.25l-.56.83c-30.72-20.33-55.67-26.88-78.52-20.59-20.58,5.66-37.55,21.25-55.52,37.75-21.57,19.79-46,42.23-81.3,51.24-36.57,9.34-55.91,8-80.4,6.35-13.61-.93-29-2-50.16-1.49-26.76.61-45.36,13.15-53.83,24.67-9.82,13.34-11.9,30.25-6.17,50.24Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f72dfe94ae3371b96dcd4a7a5fbd7d20.svg";
export { ForwardRef as ReactComponent };